import { DOMAINS_ERROR_ALERT_TAG } from 'App/featuresFlags';
import { useHasTags } from 'App/hooks';

export function useHasDomainsErrorAlertTag() {
  const [hasDomainsErrorAlertTag] = useHasTags(DOMAINS_ERROR_ALERT_TAG);
  return hasDomainsErrorAlertTag;
}
